<template>
    <section id="skills">
        <Title
          :title="$t('skills.title')"
          :description="$t('skills.description')"
        />

        <div class="section-content">
            <div class="container-fluid">
                <div class="row d-flex flex-wrap align-items-center">
                    <div class="col-md-2 m-auto pb-4" v-motion-pop-visible>
                        <img id="imgLogo" class="img-responsive mx-auto d-block" :src="require('@/assets/img/logo/3d.png')" alt="3ds Max"/>
                        <div id="divAlt" class="altCaption text-center">3ds Max</div>
                    </div>
                    <div class="col-md-2 m-auto pb-4" v-motion-pop-visible>
                        <img id="imgLogo" class="img-responsive mx-auto d-block" :src="require('@/assets/img/logo/autoc.png')" alt="AutoCad"/>
                        <div id="divAlt" class="altCaption text-center">AutoCad</div>
                    </div>
                    <div class="col-md-2 m-auto pb-4" v-motion-pop-visible>
                        <img id="imgLogo" class="img-responsive mx-auto d-block" :src="require('@/assets/img/logo/illust.png')" alt="Illustrator"/>
                        <div id="divAlt" class="altCaption text-center">Illustrator</div>
                    </div>
                    <div class="col-md-2 m-auto pb-4" v-motion-pop-visible>
                        <img id="imgLogo" class="img-responsive mx-auto d-block" :src="require('@/assets/img/logo/photoshop.png')" alt="Photoshop"/>
                        <div id="divAlt" class="altCaption text-center">Photoshop</div>
                    </div>
                    <div class="col-md-2 m-auto pb-4" v-motion-pop-visible>
                        <img id="imgLogo" class="img-responsive mx-auto d-block" :src="require('@/assets/img/logo/revit.png')" alt="Revit"/>
                        <div id="divAlt" class="altCaption text-center">Revit</div>
                    </div>
                    <div class="col-md-2 m-auto pb-4" v-motion-pop-visible>
                        <img id="imgLogo" class="img-responsive mx-auto d-block" :src="require('@/assets/img/logo/sketch.png')" alt="Sketch"/>
                        <div id="divAlt" class="altCaption text-center">SketchUp</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import Title from './Title.vue'

    export default {
        name: 'Skills',
        components: {
            Title,
        },
    }
</script>

<style scoped lang="scss">
    @import '@/styles/constants.scss';

    #skills {
        background-color: lighten(map-get($colors, dark), 100%);
    }

    @media(min-width: #{map-get($breakpoints, medium)}) {
        .section-content {
            width: 80%;
            margin: 0 auto;
        }
    }

    img{
        max-width: 120px;
    }

    .altCaption{
        color: map-get($colors, secondary);
        margin-top: 1rem;
    }
</style>
